import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { effect } from "@preact/signals-core";
import { isAvailable, shipsBy } from "../store/product-store";
import { isExtendedOfferEnabled } from "../store/extended-offer-store";
import { calculateShippingDate } from "../utils/knocking";

@customElement("ships-by-pp")
export class ShipsByPP extends LitElement {
  @property({ type: String }) format: "long" | "short" = "long";
  @state() private _shippingDate: string | null = null;
  @state() private _showSoldOut = false;

  protected createRenderRoot() {
    return this; // Light DOM for Tailwind
  }

  connectedCallback() {
    super.connectedCallback();

    effect(() => {
      const shipsByTag = shipsBy.value;
      const showSoldOut =
        !isAvailable.value && Boolean(isExtendedOfferEnabled.value);

      if (showSoldOut) {
        this._showSoldOut = true;
        this._shippingDate = null;
        return;
      }

      this._showSoldOut = false;

      if (!shipsByTag) {
        this._shippingDate = null;
        return;
      }

      try {
        const calculated = calculateShippingDate(shipsByTag);
        this._shippingDate = this.format === "short"
          ? (calculated.shortDate || calculated.longDate)
          : calculated.longDate;
      } catch (error) {
        console.error(`ships-by-pp: failed to calculate date`, error);
        this._shippingDate = null;
      }
    });
  }

  render() {
    if (this._showSoldOut) {
      return html`
        <div
          id="product-shipsby-notice"
          class="product__shipsby-notice bg-[var(--color-secondary-50)] rounded-tl-sm rounded-tr-sm uppercase text-xs text-[var(--color-primary-950)] tracking-[0.1em] py-[5.5px] px-4 text-center"
        >
          <p class="flex flex-row items-center justify-center text-center gap-1">
            <span class="text-xs font-bold text-[var(--color-secondary-950)]">Sold Out</span>
          </p>
        </div>
      `;
    }

    if (!this._shippingDate) {
      return html`<!-- ships-by-pp: no shipping date -->`;
    }

    return html`
      <div
        id="product-shipsby-notice"
        class="product__shipsby-notice bg-[var(--color-primary-50)] rounded-tl-[4px] rounded-tr-[4px] uppercase text-xs text-[var(--color-primary-950)] tracking-[0.1em] py-[5.5px] px-4 text-center flex flex-col justify-center items-center"
      >
        <p class="flex flex-row items-center justify-center text-center gap-1">
          <span class="text-xs text-[var(--color-primary-950)] uppercase">Ships by</span>
          <span class="text-xs font-bold text-[var(--color-primary-950)]">${this._shippingDate}</span>
        </p>
      </div>
    `;
  }
}
